import { createTokens } from 'tamagui'
import { color } from './colors'

/**
 * Spacing tokens
 *
 * 8 point system
 */
export const size = {
  $0: 0,
  '$0.25': 2,
  '$0.5': 4,
  '$0.75': 6,
  $1: 8,
  $2: 16,
  $3: 24,
  $4: 32,
  $true: 32, // default size
  $5: 40,
  $6: 48,
  $7: 56,
  $8: 64,
  $9: 72,
  $10: 80,
  $11: 88,
  $12: 96,
  $13: 104,
  $14: 112,
  $15: 120,
  $16: 128,
  $17: 136,
  $18: 144,
  $19: 152,
  $20: 160,
}

type SizeKeysIn = keyof typeof size
type Sizes = {
  [Key in SizeKeysIn extends `$${infer Key}` ? Key : SizeKeysIn]: number
}
type SizeKeys = `${keyof Sizes extends `${infer K}` ? K : never}`

const spaces = Object.entries(size).map(([k, v]) => [k, v] as const)
const spacesNegative = spaces.slice(1).map(([k, v]) => [`-${k.slice(1)}`, -v])

type SizeKeysWithNegatives = Exclude<`-${SizeKeys extends `$${infer Key}` ? Key : SizeKeys}`, '-0'> | SizeKeys

export const space: {
  [Key in SizeKeysWithNegatives]: Key extends keyof Sizes ? Sizes[Key] : number
} = {
  ...Object.fromEntries(spaces),
  ...Object.fromEntries(spacesNegative),
}

export const zIndex = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
}

export const radius = {
  0: 0,
  1: 2,
  2: 4,
  3: 6,
  4: 8,
  true: 8, // default
  5: 10,
  6: 16,
  7: 19,
  8: 22,
  9: 26,
  10: 34,
  11: 42,
  12: 50,
}

export const tokens = createTokens({
  color,
  radius,
  zIndex,
  space,
  size,
})
